import React from "react"
export const DownloadIcon =()=>{
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8334 8.33333H15L10 13.3333L5.00002 8.33333H9.16669V2.5H10.8334V8.33333ZM3.33335 15.8333H16.6667V10H18.3334V16.6667C18.3334 16.8877 18.2456 17.0996 18.0893 17.2559C17.933 17.4122 17.721 17.5 17.5 17.5H2.50002C2.27901 17.5 2.06704 17.4122 1.91076 17.2559C1.75448 17.0996 1.66669 16.8877 1.66669 16.6667V10H3.33335V15.8333Z" fill="#262626"/>
    </svg>
    
}